import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { SupervisionsPieChart } from './cards/SupervisionsPieChart';
import { MonthlySupervisionsChart } from './cards/MonthlySupervisionsChart';

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 18px;
  align-items: stretch;

  > div > .ant-card {
    display: flex;
    flex-direction: column;
    height: 100%;

    .ant-card-body {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
    }
  }
`;

/**
 * Component to display supervisions charts.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Array} props.supervisionsStatus - Array of supervisions status data.
 * @param {Array} props.supervisions - Array of supervisions data.
 * @param {function} props.setStatusDate - Function to set status date.
 * @param {function} props.setSupDate - Function to set supervisions date.
 *
 * @returns {React.ReactNode} - The rendered component.
 */
export const SupervisionsCharts = ({
  supervisions,
  supervisionsStatus,
  setStatusDate,
  setSupDate
}) => {
  const { t } = useTranslation();

  return (
    <StyledGrid>
      <SupervisionsPieChart
        t={t}
        supervisionsStatus={supervisionsStatus}
        setStatusDate={setStatusDate}
      />
      <MonthlySupervisionsChart
        t={t}
        supervisions={supervisions}
        setSupDate={setSupDate}
      />
    </StyledGrid>
  );
};

SupervisionsCharts.propTypes = {
  supervisionsStatus: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  supervisions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setStatusDate: PropTypes.func.isRequired,
  setSupDate: PropTypes.func.isRequired
};
